/**
 * ingatlan kereső komponenes
 * @author Erik Banhalmi 2017.06.12.
 */
import $ from 'jquery';
import { PropertySearchBarService } from './property-search-bar.service';
import mainSearchRealEstateType from '../../../modules/M03-main-search/dialogs/M03-main-search-real-estate-type.pug';
import mainSearchSaleType from '../../../modules/M03-main-search/dialogs/M03-main-search-sale-type.pug';
import mainSearchAddress from '../../../modules/M03-main-search/dialogs/M03-main-search-address.pug';
import mainSearchPrice from '../../../modules/M03-main-search/dialogs/M03-main-search-price.pug';
import mainSearchSize from '../../../modules/M03-main-search/dialogs/M03-main-search-size.pug';

const MODULE_NAME = 'propertySearchBar';
const DEFAULT_LANGUAGE = 'hu';
const LANGUAGE_COOKIE = 'language';
const SCROLL_SPEED = 1000;
const MAX_TAGS = 6;
const DEFAULT_ORDER = 'orderBy=createDateTime&orderDirection=desc';
const DEFAULT_PROPERTY_RESULT_LIST_PAGE_SIZE = 10;
const DEFAULT_FIRST_PAGE = 0;
const COMISSION_ID_REGEX = /M\d{5,}/;
const COMISSION_ID_TYPE = 'COMMISSION_ID_TYPE';

const PRICE_VALUES = [
	{ min: 0, max: 5 },
	{ min: 5, max: 10 },
	{ min: 10, max: 15 },
	{ min: 15, max: 20 },
	{ min: 20, max: 25 },
	{ min: 25, max: 30 },
	{ min: 30, max: 35 },
	{ min: 35, max: 40 },
	{ min: 40, max: 45 },
	{ min: 45, max: 50 },
	{ min: 50, max: 75 },
	{ min: 75, max: 100 },
	{ min: 100, max: null }
];

const AREA_VALUES = [
	{ min: 10, max: 40 },
	{ min: 40, max: 70 },
	{ min: 70, max: 100 },
	{ min: 100, max: 130 },
	{ min: 130, max: 160 },
	{ min: 160, max: null }
];

const REAL_ESTATE_VALUES = [
	'flat',
	'house',
	'flatPlusHouse',
	'parcel',
	'garage',
	'projectEstate',
	'office',
	'shop',
	'tourism',
	'industrial',
	'agricultural',
	'parcelForInnovation',
	'publicInstitution'
];

const SALE_VALUES = ['forSell', 'forRent'];

const ALLOWED_PROPERTIES = [
	'arId',
	'arMaximum',
	'arMinimum',
	'ertekesitestipusa',
	'ingatlantipusa',
	'meretId',
	'meretMaximum',
	'meretMinimum',
	'selectedTags',
	'page',
	'pageSize',
	'order',
	'location',
	'locationTypes',
	'comissionId'
];

class PropertySearchBarController {
	constructor(propertySearchBarService, $scope, $mdDialog, $cookies, $timeout, $filter, $translate, niceUrlService) {
		'ngInject';
		this.$cookies = $cookies;
		this.propertySearchBarService = propertySearchBarService;
		this.$scope = $scope;
		this.$mdDialog = $mdDialog;
		this.$timeout = $timeout;
		this.$filter = $filter;
		this.$translate = $translate;
		this.niceUrlService = niceUrlService;
		this.locationResult = [];
		this.realEstateValues = REAL_ESTATE_VALUES;
		this.salesValues = SALE_VALUES;
		this.MAX_TAGS = MAX_TAGS;
		this.modalData = {};
	}

	$onInit() {
		if (!this.initialized) {
			this.initialized = true;
			this.showBottomSearchBar = false;
			this.showOrHideBottomSearchBar();
			let currentLanguage = this.$cookies.get(LANGUAGE_COOKIE) ? this.$cookies.get(LANGUAGE_COOKIE) : DEFAULT_LANGUAGE;
			this.selectedTags = [];
			if (window.location.hash) {
				// megpróbáljuk az URL-ből kiszedni a  adatokat
				this.model = this.niceUrlService.preLoadDataFromNiceUrl(window.location.hash, currentLanguage);
				this.removeOtherProperties();
				this.model.ertekesitestipusa =
					this.model.ertekesitestipusa && typeof this.model.ertekesitestipusa[0] == 'number' ? this.model.ertekesitestipusa[0] + '' : '0';
				if (Array.isArray(this.model.ingatlantipusa)) {
					this.model.ingatlantipusa = this.model.ingatlantipusa[0];
				}
				this.locationTypes = [];
				// this.model.selectedTags = this.model.selectedTags || [];
				this.$scope.$emit('propertySearchBarInit');
				// APLIS layout, shiwa paraméteres keresés
			} else if (window.searchParams) {
				if (window.searchParams.hely) {
					window.searchParams.selectedTags = window.searchParams.hely.split('|');
				}
				if (window.searchParams.selectedTags) {
					window.searchParams.locationTypes = new Array(window.searchParams.selectedTags.length).fill(window.searchParams.mapType);
				}
				if (window.searchParams.ingatlantipusa) {
					window.searchParams.ingatlantipusa = parseInt(window.searchParams.ingatlantipusa, 10);
				}
				this.model = window.searchParams;
			} else {
				this.resetModel();
			}
			(this.model.selectedTags || []).forEach((tag, index) => {
				this.selectedTags.push({ value: tag, type: this.model.locationTypes[index] });
			});
			this.saveFormData();
			this.$timeout(() => {
				this.checkChipsInputClass();
			});

			this.$scope.$on('resetSearch', () => {
				this.resetModel();
				this.saveFormData();
			});

			this.$scope.$on('closePopups', () => {
				this.closeDialog();
			});
			window.ipEventBus.subscribe(
				'open-search-popup',
				(channel, { type, data }) => {
					this.openMessageForm(type, data);
				},
				true
			);
		}
	}

	resetModel() {
		// nice URL képzpsékor számít, hogy a minimum előbb legyen, mint a maximum, különben fordítva kerül be az URL-be
		this.model = {
			arMinimum: '',
			arMaximum: '',
			meretMinimum: '',
			meretMaximum: '',
			selectedTags: [],
			ertekesitestipusa: '0',
			ingatlantipusa: 2,
			pageSize: DEFAULT_PROPERTY_RESULT_LIST_PAGE_SIZE,
			page: DEFAULT_FIRST_PAGE,
			order: DEFAULT_ORDER
		};
	}

	showOrHideBottomSearchBar() {
		$(document).ready(() => {
			// let searchBar = $('#search');
			// hiába az onready event, valamiért 0 a top
			function getOffsetTop() {
				let searchBar = $('#search');
				if (searchBar.length) {
					let searchBarTopValue = searchBar.offset().top;
					if (searchBarTopValue) {
						return searchBarTopValue;
					} else {
						return window.requestAnimationFrame(getOffsetTop);
					}
				}
				return undefined;
			}

			let searchBarTop = getOffsetTop();

			$('.ip-content-container').scroll(() => {
				let searchBarHeight = $('#search').height();
				if ($(window).scrollTop() > searchBarTop + searchBarHeight) {
					this.showBottomSearchBar = true;
				} else {
					this.showBottomSearchBar = false;
				}
				if (!this.$scope.$$phase) {
					this.$scope.$apply();
				}
			});
		});
	}

	removeOtherProperties() {
		for (let key in this.model) {
			if (ALLOWED_PROPERTIES.indexOf(key) == -1) {
				delete this.model[key];
			}
		}
	}
	sendAnalytics() {
		this.$translate('ANYIT.' + REAL_ESTATE_VALUES[this.model.ingatlantipusa]).then(propertyTypeParam => {
			const propertyLocationParam = this.model.selectedTags.join(' | ');
			const salesTypeParam = this.model.ertekesitestipusa == 0 ? 'Eladó' : 'Kiadó';
			window.dataLayer.push({
				event: 'propertySearchResult',
				salesType: salesTypeParam,
				propertySize: this.model.meretMinimum + ' - ' + this.model.meretMaximum,
				propertyType: propertyTypeParam,
				propertyLocation: propertyLocationParam,
				propertyPrice: this.model.arMinimum + ' - ' + this.model.arMaximum
			});
		});
	}

	search(hideDialog, reset) {
		/** lapozó, koordináták resetelése KERESÉS-re kattintva */
		if (reset) {
			delete this.model.page;
			delete this.model.pageSize;
			delete this.model.location;
		}
		if (hideDialog) {
			this.$mdDialog.hide();
		}
		this.sendAnalytics();
		this.searchProperty({
			data: this.model
		});
	}

	querySearch(searchText) {
		if (searchText && searchText.length >= 3) {
			return this.propertySearchBarService.getPublicLocation(searchText);
		} else {
			return [];
		}
	}

	hasCommission() {
		return this.selectedTags.find(item => item.type == COMISSION_ID_TYPE);
	}

	transformChip(chip) {
		// sima string
		if (typeof chip == 'string') {
			if (COMISSION_ID_REGEX.test(chip) && !this.hasCommission()) {
				return { type: COMISSION_ID_TYPE, value: chip };
			} else {
				return null;
			}
		} else {
			return chip;
		}
	}

	openMessageForm(type, data) {
		this.modalData = this.modalData ? this.modalData : {};
		switch (type) {
			case 'sale':
				this.modalData.saleType = data;
				break;
			case 'realEstate':
				this.modalData.realEstate = data;
				break;
			case 'selectedTags':
				this.modalData.selectedTags = angular.copy(data) || [];
				break;
			case 'size':
				// this.modalData.meretMaximum = data.meretMaximum;
				// this.modalData.meretMinimum = data.meretMinimum;
				break;
			case 'price':
				// this.modalData.arMaximum = data.arMaximum;
				// this.modalData.arMinimum = data.arMinimum;
				break;
			default:
				break;
		}
		this.$mdDialog.show({
			multiple: true,
			template: this.getPopupTemplateByType(type),
			clickOutsideToClose: true,
			controller: () => this,
			controllerAs: '$ctrl'
		});
	}

	closeDialog() {
		this.$mdDialog.hide();
	}

	sendDialogData(data) {
		window.ipEventBus.publish('send-search-popup-data', data);
	}

	saveDialogData(data, type) {
		switch (type) {
			case 'sale':
				this.sendDialogData({ ertekesitestipusa: data });
				this.model.ertekesitestipusa = data;
				break;
			case 'realEstate':
				this.sendDialogData({ ingatlantipusa: data });
				this.model.ingatlantipusa = data;
				break;
			case 'selectedTags':
				this.sendDialogData({ selectedTags: angular.copy(data) || [] });
				this.selectedTags = angular.copy(data) || [];
				this.model.selectedTags = data.map(tag => tag.value) || [];
				this.model.locationTypes = data.map(tag => tag.type) || [];
				break;
			case 'price':
				this.sendDialogData({
					arId: data.arId,
					arMinimum: data.arMinimum,
					arMaximum: data.arMaximum
				});
				// this.model.arId = data.arId;
				// this.model.arMinimum = data.arMinimum || '';
				// this.model.arMaximum = data.arMaximum || '';
				break;
			case 'size':
				this.sendDialogData({
					meretId: data.meretId,
					meretMinimum: data.meretMinimum,
					meretMaximum: data.meretMaximum
				});
				// this.model.meretId = data.meretId;
				// this.model.meretMinimum = data.meretMinimum || '';
				// this.model.meretMaximum = data.meretMaximum || '';
				break;
			default:
				break;
		}
		this.saveFormData();
		this.$mdDialog.hide();
	}

	saveFormData() {
		this.saveFormDataFunction({
			data: this.model
		});
	}

	scrollTo(id) {
		$('html, body').animate(
			{
				scrollTop: $(id).offset().top
			},
			SCROLL_SPEED
		);
	}

	getPopupTemplateByType(type) {
		switch (type) {
			case 'realEstate':
				return mainSearchRealEstateType();
			case 'sale':
				return mainSearchSaleType();
			case 'selectedTags':
				return mainSearchAddress();
			case 'price':
				return mainSearchPrice();
			case 'size':
				return mainSearchSize();
			default:
				return '';
		}
	}

	millionOrThousand() {
		return this.model.ertekesitestipusa == '1' ? 'eFt' : 'mFt';
	}

	ingatlanTipusDisplay() {
		let resultString = '';
		if (this.model && this.model.ingatlantipusa > -1) {
			resultString = this.$filter('translate')('ANYIT.' + this.realEstateValues[this.model.ingatlantipusa]);
		}
		return resultString;
	}

	selectedTagsDisplay() {
		let resultString = '';
		if (this.model && this.model.selectedTags) {
			resultString = this.model.selectedTags.join(',');
		}
		return resultString;
	}

	selectPrice(selectedId, modelName) {
		this.modalData.arId = selectedId;
		this[modelName].arMinimum = PRICE_VALUES[selectedId].min;
		this[modelName].arMaximum = PRICE_VALUES[selectedId].max;
		this.saveFormData();
	}

	selectArea(selectedId, modelName) {
		this.modalData.meretId = selectedId;
		this[modelName].meretMinimum = AREA_VALUES[selectedId].min;
		this[modelName].meretMaximum = AREA_VALUES[selectedId].max;
		this.saveFormData();
	}

	/* checkIfRealEstateExists(index) {
		return this.modalData.realEstate ? this.modalData.realEstate.indexOf(index + '') > -1 : false;
	} */

	toggleRealEstate(index) {
		this.modalData.realEstate = index;
	}

	clearSelectInputField(field, dontSave) {
		this[field] = '';
		if (dontSave) {
			// ne
		} else {
			this.saveFormData();
		}
	}

	onChangeChip(val) {
		// koordináta adatok törlése ha van
		if (this.model.hasOwnProperty('location')) {
			delete this.model.location;
		}
		this.model.selectedTags = this.selectedTags && this.selectedTags.filter(item => item.type != COMISSION_ID_TYPE).map(item => item.value);
		this.model.locationTypes = this.selectedTags && this.selectedTags.filter(item => item.type != COMISSION_ID_TYPE).map(item => item.type);
		this.model.comissionId = this.selectedTags && (this.selectedTags.find(item => item.type == COMISSION_ID_TYPE) || {}).value;
		this.checkChipsInputClass();
		this.saveFormData();
	}

	checkChipsInputClass() {
		if (this.model.selectedTags && this.model.selectedTags.length >= this.MAX_TAGS) {
			$('.md-chip-input-container').addClass('ng-hide');
		} else {
			$('.md-chip-input-container').removeClass('ng-hide');
		}
	}

	setIntervalButtonText(min, max, translationKey) {
		if (this.model[min] || this.model[max]) {
			this.model[min] = this.model[min] ? this.model[min] : '';
			this.model[max] = this.model[max] ? this.model[max] : '';
			return this.model[min] + ' - ' + this.model[max];
		} else {
			return this.$filter('translate')(translationKey);
		}
	}

	/**
	 * Chips validáció
	 */
	validateChipsField() {
		this.$timeout(() => {
			if ($('.ng-invalid-md-require-match').length > 0) {
				this.searchText = '';
			}
		});
	}
}

import niceUrlModule from './../../niceUrl/nice-url.module';

export default angular
	.module(MODULE_NAME, [niceUrlModule])
	.component('propertySearchBar', {
		controller: PropertySearchBarController,
		bindings: {
			searchProperty: '&',
			saveFormDataFunction: '&'
		}
	})
	.service('propertySearchBarService', PropertySearchBarService).name;
